/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Content_Responsible_TextInputs */

const en_impressum_content_responsible_text = /** @type {(inputs: Impressum_Content_Responsible_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsible for content pursuant to Section 18(2) MStV:`)
};

const de_impressum_content_responsible_text = /** @type {(inputs: Impressum_Content_Responsible_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verantwortlich fuer den Inhalt gemaess SS 18 Abs. 2 MStV:`)
};

const fr_impressum_content_responsible_text = /** @type {(inputs: Impressum_Content_Responsible_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsable du contenu conformément au § 18(2) MStV :`)
};

const es_impressum_content_responsible_text = /** @type {(inputs: Impressum_Content_Responsible_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsable del contenido conforme al artículo 18(2) MStV:`)
};

const it_impressum_content_responsible_text = /** @type {(inputs: Impressum_Content_Responsible_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabile del contenuto ai sensi del §18(2) MStV:`)
};

const nl_impressum_content_responsible_text = /** @type {(inputs: Impressum_Content_Responsible_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verantwoordelijk voor de inhoud conform § 18 lid 2 MStV:`)
};

const pl_impressum_content_responsible_text = /** @type {(inputs: Impressum_Content_Responsible_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpowiedzialny za treść na podstawie § 18 ust. 2 MStV:`)
};

const fi_impressum_content_responsible_text = /** @type {(inputs: Impressum_Content_Responsible_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sisällöstä vastaava MStV:n 18 §:n 2 momentin mukaisesti:`)
};

const da_impressum_content_responsible_text = /** @type {(inputs: Impressum_Content_Responsible_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansvarlig for indhold i henhold til § 18 stk. 2 MStV:`)
};

const sv_impressum_content_responsible_text = /** @type {(inputs: Impressum_Content_Responsible_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansvarig för innehåll enligt 18 st. 2 MStV:`)
};

/**
* | output |
* | --- |
* | "Responsible for content pursuant to Section 18(2) MStV:" |
*
* @param {Impressum_Content_Responsible_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_content_responsible_text = /** @type {((inputs?: Impressum_Content_Responsible_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Content_Responsible_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_content_responsible_text(inputs)
	if (locale === "fr") return fr_impressum_content_responsible_text(inputs)
	if (locale === "es") return es_impressum_content_responsible_text(inputs)
	if (locale === "it") return it_impressum_content_responsible_text(inputs)
	if (locale === "nl") return nl_impressum_content_responsible_text(inputs)
	if (locale === "pl") return pl_impressum_content_responsible_text(inputs)
	if (locale === "fi") return fi_impressum_content_responsible_text(inputs)
	if (locale === "da") return da_impressum_content_responsible_text(inputs)
	if (locale === "sv") return sv_impressum_content_responsible_text(inputs)
	return en_impressum_content_responsible_text(inputs)
});